export default __webpack_public_path__ + "static/media/hero4.6ea67aaa.jpg";